import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: "0px"
  }} data-id="element-610" data-mp="38vu7s8uzq744">
      <div className="mx-auto max-w-3xl space-y-14" data-id="element-611" data-mp="2v0i0z33k8q6u">

        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-612" data-mp="2yxxp8vzq49vz">
          <p className="text-[12px] font-semibold uppercase tracking-[0.28em] text-[#C8A870] md:text-[13px]" data-id="element-613" data-mp="2bag0787ufpwp">
            Una historia que podría ser la tuya
          </p>
          
        </motion.div>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium relative overflow-hidden p-6 md:p-10" style={{
        paddingTop: "20px"
      }} data-id="element-614" data-mp="22aszypquoq58">
          {/* Línea lateral */}
          <div className="absolute bottom-0 left-0 top-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-615" data-mp="5fsw33ngppl6" />

          <div className="pl-3 md:pl-6" data-id="element-616" data-mp="hrb2d6h7g72">

            {/* Historia colapsable */}
            <div className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${storyExpanded ? 'max-h-[1400px]' : 'max-h-[330px]'}`} data-id="element-617" data-mp="38vzyl6u55gsd">
              <div className="space-y-5 md:space-y-6" data-id="element-618" data-mp="33vdajo14elex">

                {/* Inicio */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-619" data-mp="3innhgjcmtpi8">
                  Mónica tenía 49 años.
                  <br data-id="element-620" data-mp="2q5i5v29b6l70" />
                  Comía bien, caminaba y se acostaba temprano.
                </p>

                {/* Situación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-621" data-mp="2l6fbqcuv9zdt">
                  Pero hacía meses que algo no cerraba. Se despertaba cansada,
                  incluso después de dormir sus horas.
                </p>

                {/* Intentos previos */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-622" data-mp="yuf0u1d2zc0q">
                  Hizo lo que cualquiera haría: ajustó comidas, caminó más e
                  intentó dormir mejor.
                </p>

                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-623" data-mp="b3riem5jh3zx">
                  Y su cuerpo ya no respondía igual a lo que antes le
                  funcionaba.
                </p>

                {/* Insight */}
                <p className="pt-1 font-body text-[17px] font-medium italic leading-[1.6] text-[#F0E8D8] md:text-[19px]" data-id="element-624" data-mp="k2mkbm1jvrxf">
                  Hasta que entendió que no le faltaba esfuerzo. Le faltaba
                  orden: saber qué priorizar, cuándo y cómo sostenerlo.
                </p>

                {/* Divider */}
                <div className="divider-fine !mt-7 w-full" data-id="element-625" data-mp="20oq2ihf7m0og" />

                {/* H.E.R. */}
                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-626" data-mp="1vy009d22ydxz">
                  Para eso existe H.E.R.
                  <br data-id="element-627" data-mp="1rvd44zydm6uz" />
                  21 días para organizar alimentación, movimiento y descanso,
                  con una guía clara para cada día.
                </p>

              </div>

              {/* Fade */}
              {!storyExpanded && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#120f0d] via-[#120f0d]/90 to-transparent" data-id="element-628" data-mp="1i0be81wa10rc" />}
            </div>

            {/* Toggle */}
            <div className="mt-5 flex justify-center" data-id="element-629" data-mp="18zdbdmxkqzac">
              <button type="button" onClick={() => setStoryExpanded(value => !value)} aria-expanded={storyExpanded} className="inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A870] transition-opacity duration-300 hover:opacity-70" data-id="element-630" data-mp="37dgaqdn4i9o4">
                <span data-id="element-631" data-mp="3fee5g8g3dus1">
                  {storyExpanded ? 'Ocultar historia' : 'Leer la historia completa'}
                </span>

                <span className={`transition-transform duration-300 ${storyExpanded ? 'rotate-180' : ''}`} data-id="element-632" data-mp="31dbk5xwx8oi6">
                  ↓
                </span>
              </button>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}